import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { ExperiencesInfoModal } from "./component";
import {
  getFetchRewardsAccountsCallState,
  getRewardsAccountWithLargestValue,
} from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestValue(state),
  fetchRewardsAccountsCallState: getFetchRewardsAccountsCallState(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesInfoModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedExperiencesInfoModal = withRouter(
  connector(ExperiencesInfoModal)
);
